import React from "react";

interface CompanyManagementFiltersProps {
  searchTerm: string;
  selectedStatus: string;
  selectedTier: string;
  onSearchTermChange: (value: string) => void;
  onApplyFilters: () => void;
  onStatusChange: (value: string) => void;
  onTierChange: (value: string) => void;
}

const CompanyManagementFilters: React.FC<CompanyManagementFiltersProps> = ({
  searchTerm,
  selectedStatus,
  selectedTier,
  onSearchTermChange,
  onApplyFilters,
  onStatusChange,
  onTierChange,
}) => (
  <div className="mb-6 space-y-4 rounded-lg bg-white p-4 shadow">
    <div className="flex flex-col gap-3 md:flex-row md:items-end">
      <div className="flex-1">
        <label className="mb-1 block text-sm text-gray-600">Search</label>
        <input
          type="text"
          placeholder="Search by company name"
          value={searchTerm}
          onChange={(event) => onSearchTermChange(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              onApplyFilters();
            }
          }}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />
      </div>

      <div>
        <label className="mb-1 block text-sm text-gray-600">
          Subscription status
        </label>
        <select
          value={selectedStatus}
          onChange={(event) => onStatusChange(event.target.value)}
          className="rounded-lg border border-gray-300  focus:outline-none focus:ring-2 focus:ring-indigo-500"
        >
          <option value="">All status</option>
          <option value="TRIAL">Trial</option>
          <option value="ACTIVE">Active</option>
          <option value="PAST_DUE">Past due</option>
          <option value="CANCELLED">Cancelled</option>
          <option value="EXPIRED">Expired</option>
        </select>
      </div>

      <div>
        <label className="mb-1 block text-sm text-gray-600">Tier</label>
        <select
          value={selectedTier}
          onChange={(event) => onTierChange(event.target.value)}
          className="rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
        >
          <option value="">All tiers</option>
          <option value="STARTER">Starter</option>
          <option value="PRO">Pro</option>
          <option value="ENTERPRISE">Enterprise</option>
        </select>
      </div>

      <button
        type="button"
        onClick={onApplyFilters}
        className="rounded-lg bg-indigo-600 px-4 py-2 text-white hover:bg-indigo-700"
      >
        Apply filters
      </button>
    </div>
  </div>
);

export default CompanyManagementFilters;
